import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class FaqService {
  constructor(private api: ApiService) {}

  // Get FAQs by project ID
  getFaqsByProject(
    projectId: string,
    search?: string,
    moduleFilter?: string,
    sortOrder?: 'asc' | 'desc'
  ): Observable<any[]> {
    let url = `/faq/project/${projectId}`;
    const params: string[] = [];

    if (search?.trim()) params.push(`search=${encodeURIComponent(search)}`);
    if (moduleFilter) params.push(`module=${encodeURIComponent(moduleFilter)}`);
    if (sortOrder) params.push(`sortOrder=${sortOrder}`);

    if (params.length) url += `?${params.join('&')}`;

    return this.api.get<any[]>(url);
  }

  // Optional: Add new FAQ
  uploadFaq(data: any): Observable<any> {
    return this.api.post(`/faq/upload`, data);
  }

  // ✅ Get all projects (for mapping module → projectId)
  getAllProjects(): Observable<any[]> {
    return this.api.get<any[]>(`/projects`);
  }
}
